// ===================================================
// MobileTopBar.js — 모바일 전용 상단 내비게이션 바 (GNB)
//
// 역할:
//   - 모바일 화면(768px 이하)에서만 표시되는 상단 바
//   - 좌측에 현재 페이지 타이틀을 표시합니다.
//   - 우측에 검색·설정 아이콘을 제공합니다.
//     (설정 아이콘은 설정/알림설정/어드민 화면에서 중복 방지를 위해 숨김)
//     (검색 아이콘은 검색 화면에서 숨김)
// ===================================================

import './MobileTopBar.css';

function MobileTopBar({ screen, showAuth, onOpenSearch, onOpenSettings, pageTitle }) {
  // 설정 아이콘: 설정 계열 화면에서는 중복이므로 숨김
  const showSettingsBtn = screen !== 'settings' && screen !== 'push-settings'
    && screen !== 'admin' && !showAuth;
  // 검색 아이콘: 검색 화면 자체에서는 숨김
  const showSearchBtn = screen !== 'search';

  return (
    <div className="mobile-top-bar">
      {/* 좌측: 페이지 타이틀 */}
      <div className="mobile-top-bar-title">
        {pageTitle || ''}
      </div>

      {/* 우측: 액션 버튼들 */}
      <div className="mobile-top-bar-actions">
        {showSearchBtn && (
          <button
            className="mobile-top-bar-btn"
            onClick={onOpenSearch}
            aria-label="검색"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="7" />
              <line x1="17" y1="17" x2="22" y2="22" />
            </svg>
          </button>
        )}
        {showSettingsBtn && (
          <button
            className="mobile-top-bar-btn"
            onClick={onOpenSettings}
            aria-label="설정"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="3" />
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}

export default MobileTopBar;
